<template>
  <div>
    <h2 class="profile-page-title">{{ $t('personal_data') }}</h2>
    <form
      class="profile-form"
      @submit.prevent="saveProfile"
    >
      <div class="container">
        <fieldset class="profile-form__fieldset">
          <legend class="profile-form__legend">
            {{ $t('first_last_name') }}:
          </legend>
          <div class="row">
            <div class="col-sm-4">
              <base-input
                required
                type="text"
                class="profile-form__control"
                :placeholder="$t('first_last_name_parent')"
                :disabled="disabled"
                :error="getError('name')"
                v-model="user.profile.name"
              />
            </div>
          </div><!-- /.row -->
        </fieldset>

        <fieldset class="profile-form__fieldset">
          <legend class="profile-form__legend">
            {{ $t('contact_information') }}:
          </legend>
          <div class="row">
            <div class="col-sm-4">
              <base-input
                required
                type="text"
                class="profile-form__control"
                :placeholder="$t('country')"
                :disabled="disabled"
                :error="getError('country')"
                v-model="user.profile.country"
              />
            </div>

            <div class="col-sm-4">
              <base-input
                required
                type="text"
                class="profile-form__control"
                :placeholder="$t('city')"
                :disabled="disabled"
                :error="getError('city')"
                v-model="user.profile.city"
              />
            </div>

            <div class="col-sm-4">
              <base-input
                required
                type="text"
                class="profile-form__control"
                :placeholder="$t('zip_code')"
                :disabled="disabled"
                :error="getError('index')"
                v-model="user.profile.index"
              />
            </div>

            <div class="col-sm-4">
              <base-input
                required
                type="text"
                class="profile-form__control"
                :placeholder="$t('address')"
                :disabled="disabled"
                :error="getError('address')"
                v-model="user.profile.address"
              />
            </div>

            <div class="col-sm-4">
              <base-input
                      required
                      type="tel"
                      class="profile-form__control mb-0"
                      :placeholder="$t('phone')"
                      :disabled="true"
                      v-model="user.phone"
              />
              <router-link class="change-number-link" to="/user/profile/phone">
                {{ $t('change_phone') }}
              </router-link>
            </div>

            <div class="col-sm-4">

              <base-input
                      required
                      type="tel"
                      class="profile-form__control mb-0"
                      :placeholder="$t('email')"
                      :disabled="true"
                      v-model="user.email"
              />
              <router-link v-if="!user.email" class="change-number-link" to="/user/profile/email">
                {{ $t('add_email') }}
              </router-link>
            </div>
          </div><!-- /.row -->
        </fieldset>

        <div class="mb-4">
          <a
            href="javascript:;"
            v-if="disabled"
            @click="disabled = !disabled"
          >
            {{ $t('change') }}
          </a>

          <div v-else>
            <button
              class="btn btn-success"
              type="submit"
            >
              {{ $t('save') }}
            </button>

            <button
              class="btn btn-link"
              type="button"
              @click="disabled = !disabled"
            >
              {{ $t('cancel') }}
            </button>
          </div>
        </div>
      </div><!-- /.container -->
    </form>

    <form v-if="user && user.email"
      class="profile-form__account"
      @submit.prevent="savePassword"
    >
      <div class="container">
        <fieldset class="profile-form__fieldset">
          <legend class="profile-form__legend">
            {{ $t('change_password') }}:
          </legend>
          <div class="row">
            <div class="col-sm-4">
              <base-input
                required
                type="password"
                class="profile-form__control"
                :placeholder="$t('current_password')"
                :error="getError('oldPassword')"
                v-model="currentPassword"
              />
            </div>

            <div class="col-sm-4">
              <base-input
                required
                type="password"
                class="profile-form__control"
                :placeholder="$t('new_password')"
                :error="getError('password')"
                v-model="password"
              />
            </div>

            <div class="col-sm-4">
              <base-input
                required
                type="password"
                class="profile-form__control"
                :placeholder="$t('repeat_password')"
                v-model="passwordConfirm"
              />
            </div>
          </div><!-- /.row -->
        </fieldset>

        <button
          type="submit"
          class="btn btn-default"
          :disabled="!passwordValid"
        >
          {{ $t('save') }}
        </button>
      </div><!-- /.container -->
    </form>
  </div>
</template>

<script>
import JwtService from '@/data/jwt.service';
import userApi from '@/data/UserApi';

export default {
  name: 'Edit',

  data() {
    return {
      disabled: true,
      user: {
        // ...properties
        profile: {}
      },
      error: null,

      currentPassword: null,
      passwordConfirm: null,
      password: null,
    }
  },

  created() {
    this.fetchProfile();
  },

  computed: {
    passwordValid() {
      return (this.password && this.currentPassword && (this.password === this.passwordConfirm));
    }
  },

  methods: {
    fetchProfile() {
      userApi.fetchProfile()
        .then(response => {
          this.user = response;
          userApi.utm()
        });
    },

    getError(name) {
      let errors = [];

      if (this.error) {
        this.error.map(field => {
          if (field.field === name) {
            errors.push(field.message);
          }
        });
      }

      if (errors.length > 0) {
        return errors.join(', ');
      }

      return null;
    },

    saveProfile() {
      userApi.updateProfile(this.user.profile)
        .then(response => {
          this.user.profile = response;
          this.disabled = true;
          JwtService.saveUser(this.user);
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.error = this.$t('error_401');
          } else {
            this.error = error.response.data;
          }
        });
    },

    savePassword() {
      userApi.password(this.currentPassword, this.password)
        .then(() => {
          this.password = this.currentPassword = this.passwordConfirm = null;
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.error = this.$t('error_invalid_login')
          } else {
            this.error = error.response.data;
          }
        });
    }
  }
}
</script>

<style>
  .profile-form__legend {
    font-family: 'Intro Bold', 'Open Sans', sans-serif;
    font-size: 1rem;
    margin-bottom: 15px;
  }
  .profile-form__control {
    margin-bottom: 30px;
  }
  .profile-form__account {
    background-color: #e7f1f3;
    padding: 50px 0;
  }
</style>
